import { DomElements } from './DomElements';
import $ from 'jquery';
import 'owl.carousel.es6';
import autosize from 'autosize';

window.addEventListener('DOMContentLoaded', () => {
  const { elements: dom } = DomElements;

  ///////////////////////////////////////
  // Set battery level
  ///////////////////////////////////////
  const batteryLevel = dom.batteryLevel.dataset.batteryLevel;
  dom.batteryFill.style.width = batteryLevel + '%';
  dom.batteryNumber.textContent = batteryLevel + '%';
  if (batteryLevel <= 15) {
    dom.batteryFill.style.color = '#FF5B5B'; // red
  } else if (batteryLevel <= 35) {
    dom.batteryFill.style.color = '#EEE92A'; // yellow
  }
  ///////////////////////////////////////
  // END Set battery level
  ///////////////////////////////////////


  ///////////////////////////////////////
  // Set tile-location carousel
  ///////////////////////////////////////
  $('.tile-location__carousel').owlCarousel({
    loop: false, // Need this to be false so the counter reads correcltly
    nav: true,
    dots: false,
    autoHeight: false,
    navText: ['<span class="slider-nav slider-prev"><i class="fal fa-chevron-left"></i></span>', '<span class="slider-nav slider-next"><i class="fal fa-chevron-right"></i></span>'],
    margin: 0,
    items: 1,
    onInitialized: counter, //When the plugin has initialized.
    onTranslated: counter //When the translation of the stage has finished.
  });
  function counter(event) {
    var element = event.target;         // DOM element, in this example .owl-carousel
    var items = event.item.count;     // Number of items
    var item = event.item.index + 1;     // Position of the current item

    // it loop is true then reset counter from 1
    if (item > items) {
      item = item - items
    }
    $('.tile-location__carousel-counter').html(`<strong>${item}</strong> of ${items}`)
  }
  ///////////////////////////////////////
  // END Set tile-location carousel
  ///////////////////////////////////////


  ///////////////////////////////////////
  // Set health status carousel
  ///////////////////////////////////////
  $('.health-status__carousel').owlCarousel({
    loop: false,
    nav: true,
    margin: 8,
    dots: false,
    autoHeight: false,
    navText: ['<span class="slider-nav slider-prev"><i class="fal fa-chevron-left"></i></span>', '<span class="slider-nav slider-next"><i class="fal fa-chevron-right"></i></span>'],
    items: 2,
    onRefreshed: function () {
      // Set equal height on the health status section
      const desiredHeight = Array.from(dom.healthStatusSlides).reduce((accumulator, currentValue) => {
        return accumulator = (currentValue.offsetHeight > accumulator) ? currentValue.offsetHeight : accumulator;
      }, 0)
      dom.healthStatusSlides.forEach(status => {
        status.style.minHeight = desiredHeight + 'px';
      })
    }
  });
  ///////////////////////////////////////
  // END Set health status carousel
  ///////////////////////////////////////


  ///////////////////////////////////////
  // Set responders quantity on dashboard responders tile
  ///////////////////////////////////////
  dom.respondersAmount.textContent = dom.responders.children.length;
  ///////////////////////////////////////
  // END Set responders quantity on dashboard responders tile
  ///////////////////////////////////////


  ///////////////////////////////////////
  // Add click events to 'view more' buttons on the dashboard
  ///////////////////////////////////////
  dom.viewMoreTileBtns.forEach(btn => {
    btn.addEventListener('click', e => {
      e.currentTarget.textContent = (e.currentTarget.parentElement.className.includes('view-more')) ? 'View More' : 'View Less';
      e.currentTarget.parentElement.classList.toggle('view-more');
    })
  })
  ///////////////////////////////////////
  // END Add click events to 'view more' buttons on the dashboard
  ///////////////////////////////////////


  ///////////////////////////////////////
  // Event listeners for the popups
  ///////////////////////////////////////
  dom.popupTriggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      dom.popups.forEach(popup => {
        if (trigger.dataset.popupRevealTarget === popup.dataset.popupTarget) {
          popup.classList.add('is-active');
        }
        // trigger autosize for textareas
        dom.textAreas.forEach(textArea => {
          autosize.update(textArea);
        })
      })
    })
  })

  // close popups
  dom.popupClose.forEach(btn => {
    btn.addEventListener('click', () => {
      dom.popups.forEach(popup => {
        popup.classList.remove('is-active');
      })
    })
  })

  dom.popups.forEach(popup => {
    popup.addEventListener('click', e => {
      if (!e.target.closest('.popup')) {
        popup.classList.remove('is-active');
      }
    })
  })
  ///////////////////////////////////////
  // END Event listeners for the popups
  ///////////////////////////////////////


  ///////////////////////////////////////
  // Auto resize textareas
  ///////////////////////////////////////
  autosize(dom.textAreas);
  ///////////////////////////////////////
  // END Auto resize textareas
  ///////////////////////////////////////


  ///////////////////////////////////////
  // Function for displaying the "notes" text
  ///////////////////////////////////////
  const displayNoteTextIfHasNotes = accordion => {
    const hasNotes = accordion.querySelector('.accordion__body textarea').value.toString().length;
    const notesArea = accordion.querySelector('.accordion__notes');
    if (notesArea) {
      notesArea.classList[(hasNotes) ? 'add' : 'remove']('has-notes');
    }
  }
  ///////////////////////////////////////
  // END Function for displaying the "notes" text
  ///////////////////////////////////////


  ///////////////////////////////////////
  // Display "notes" text on accordion if there are notes
  ///////////////////////////////////////
  dom.accordions.forEach(accordion => {
    displayNoteTextIfHasNotes(accordion);
  })
  ///////////////////////////////////////
  // END Display "notes" text on accordion if there are notes
  ///////////////////////////////////////


  ///////////////////////////////////////
  // Accordion functionality
  ///////////////////////////////////////
  dom.accordionTriggers.forEach(trigger => {
    trigger.addEventListener('click', e => {
      const accordion = e.target.closest('.accordion');
      accordion.classList.toggle('is-active');
      let textArea = e.currentTarget.nextElementSibling.querySelector('textarea');
      autosize.update(textArea);
      displayNoteTextIfHasNotes(accordion);
    })
  })
  ///////////////////////////////////////
  // END Accordion functionality
  ///////////////////////////////////////

})
